<template>
    <div class="wrapper" ref="wrapper">
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import BScroll from "better-scroll"
    export default {
        name: "Scroll",
        props:{
            probeType: {
                type:Number,
                default:0
            },
            pullUpLoad:{
                type:Boolean,
                default:false
            }
        },
        data(){
            return{
                scroll:null,
            }
        },
        mounted() {
            console.log("--111--");
            this.scroll=new BScroll(this.$refs.wrapper,{
                click:true,
                probeType:this.probeType,
                pullUpLoad: this.pullUpLoad

            });
            this.scroll.on('scroll',(position)=>{
                // console.log(position)
                this.$emit('scroll',position)
            });
            this.scroll.on('pullingUp',()=>{
                // console.log('上拉加载更多');
                this.$emit('pullingUp')
            });
            // console.log(this.scroll);
        },
        methods:{
            scrollTo(x,y,time=300){
                this.scroll && this.scroll.scrollTo && this.scroll.scrollTo(x,y,time);
                // console.log("--------")

            },
            finishPullUp(){
                this.scroll.finishPullUp();
            },
            refresh(){
                console.log("---333-");
                this.scroll && this.scroll.refresh();
            },
            getScrollY(){
              return this.scroll ? this.scroll.y :0
            },
        }
    }
</script>

<style scoped>

</style>